import React from 'react';
import { useFormContext } from 'react-hook-form';
import BtnFilled from '../../../components/BtnFilled';
import BtnOutlined from '../../../components/BtnOutlined';
import ControlledDropdown from '../../../components/ControlledDropdown';
import { usePermissionsStore } from '../state/use-permissions-store';

const PermissionsControls = ({ roles, onSave }) => {
  const { isLoading } = usePermissionsStore();
  const {
    reset,
    formState: { isDirty, isSubmitting },
  } = useFormContext();

  const isDisabled = !isDirty || isSubmitting || isLoading;

  return (
    <div className="max-w-7xl mx-auto bg-white shadow-md rounded-3xl p-4 mt-6">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
        <ControlledDropdown
          name="role"
          className="min-w-[200px]"
          valkey="key"
          optkey="name"
          label="Выберите роль"
          placeholder={'Выберите роль'}
          options={roles}
          isSearchable={false}
          isClearable={false}
        />

        <div className="flex gap-3">
          <BtnOutlined className="w-fit" title="Сбросить" disabled={isDisabled} btnCb={() => reset()} />
          <BtnFilled className="min-w-max" title="Сохранить" disabled={isDisabled} btnCb={onSave} />
        </div>
      </div>
    </div>
  );
};

export default PermissionsControls;
